import {config} from '../config/config';

const {login} = config.get('apiUrls');

export const ERROR_REPORT = () => `${login}/userError/report`;
